import styled from "@emotion/styled";

const Badge = styled.small`
    display: inline-block;
    padding: 0.5em 1em;
    border-radius: 1em;
    color: var(--color-${p=>p.variant||'primary'}-main);
    background-color: var(--color-${p=>p.variant||'primary'}-light);
`;

export default Badge;
